<template>
  <div id="layout-admin" class="ls-height-inherit">
    <main >
      <div class="container-fluid">
        <PageLoader></PageLoader>
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import store from 'src/vuex'

export default {
  name: 'app',
  store: store,
  computed: {
    ...mapGetters(['currentUser', 'isLogged'])
  }
}
</script>

<style lang="scss">
div[class*="payment-method-box"] {
  display: inline-block;
  transition: transform 0.2s ease;
}
div[class*="payment-method-box"]:hover {
  cursor: pointer;
  transform: translateY(-10px);
}

.subscribe-wrapper {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  color: #717787;
  main {
    margin-top: 32px;
    flex: 1 0 auto;
  }
}

.main-header {
  line-height: 55px;
  padding: 15px;
  text-align: center;
  width: 100%;
  z-index: 999;
  .subtitle {
    color: #00a0c4;
  }
  @media screen and (max-width: 768px) {
    line-height: 26px;
    background: #393c46;
    color: #fff;
    display: block;
    transition: all 0.5s ease;
    z-index: 99;
    top: 0;
    opacity: 0.9;
    .trade-name {
      cursor: pointer;
    }
    .subtitle {
      color: #fff!important;
      font-size: 22px;
      margin-bottom: 0;
    }
  }
}

.ls-alert-danger ~ header {
  padding-top: 90px;
}

.subtitle {
  font-size: 30px;
  font-weight: 100;
  text-align: center;
  -webkit-font-smoothing: antialiased;
}

.ls-label-text {
  color: #6e768d;
  font-weight: bold;
  font-size: 12px;
}

.box-group {
  align-items: center;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  justify-content: center;
  .ls-box {
    &:hover {
      transform: scale(1.08);
      box-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: 768px) {
        transform: none;
      }
    }
  }
  .main-footer, &:after {
    height: 142px;
  }
}

.main-footer {
  position: relative;
  z-index: 0;
  overflow: hidden;
  text-align: center;
  padding: 20px 0;
  width: 100%;
  height: 128px;
  @media screen and (max-width: 768px) {
    height: 155px;
  }
}

.ls-error {
  input {
    background: rgba(255, 0, 0, 0.05);
  }
}

$default: #e2e6e7;
$color-act: #2fcc71;
$custom-color: #f66466;

.btn {
  border: none;
  background: $default;
  border-radius: 4px;
  color: #909ea1;
  cursor: pointer;
  font-size: 13px;
  padding: 14px;
  transition: all 0.2s;
  &:hover {
    background: darken($default, 5%);
  }
  &.btn-lg {
    font-size: 16px;
    padding: 14px;
  }
  &.btn-fixed-bottom-xs {
    @media screen and (max-width: 768px) {
      &.next {
        right: 0;
        width: 50%;
        span {
          float: right;
          position: absolute;
          right: 15px;
        }
      }
      &.prev {
        left: 0;
        width: 50%;
        span {
          float: left;
          position: absolute;
          left: 15px;
        }
      }
      &.once {
        left: 0;
        width: 100%;
      }
      display: block;
      position: fixed;
      bottom: 0;
      z-index: 999;
      border-radius: 0;
      padding: 18px;
    }
  }
}

.btn-act {
  border: none;
  background: $color-act;
  color: #fff;
  &:hover {
    background: lighten($color-act, 10%);
  }
  &:disabled {
    background-color: lighten($color-act, 25%);
    cursor: not-allowed;
    &:hover {
      background-color: lighten($color-act, 25%);
    }
  }
}

.btn-custom {
  background-color: $custom-color;
  border: none;
  color: #fff;
  &:hover {
    background-color: lighten($custom-color, 10%)!important;
  }
  &:disabled {
    background-color: lighten($custom-color, 25%)!important;
    cursor: not-allowed;
    &:hover {
      background-color: lighten($custom-color, 25%)!important;
    }
  }
}
.ls-display-flex {
  display: flex;
}
.full-height {
  height: 100%
}
.ls-no-outline {
  background: none;
  box-shadow: none;
  outline: 0;
}
.ls-box-body {
  strong {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.ls-label-text-prefix {
  border: 1px solid #ddd;
  color: #a2a2a2;
  min-width: 48px;
}
.ls-error {
  .ls-custom-select {
    border-color: #d75553;
    &:after {
      border-color: #d75553;
    }
    &:before {
      border-color: #d75553 transparent transparent transparent;
    }
  }
  > .ls-label-text-prefix {
    border: 1px solid blue!important;
  }
  ::-webkit-input-placeholder {
    color: #d75553;
  }
  ::-moz-placeholder {
    color: #d75553;
  }
}
.ls-board-box .ls-box .ls-box-head {
  font-family: Open Sans;
  font-size: 14px;
}
.ls-board-box .ls-box .ls-box-body strong {
  font-family: Open Sans;
  font-size: 32px;
  line-height: 2;
}
@media (max-width: 468px) {
  .ls-table.ls-sm-space th, .ls-table.ls-sm-space td, .ls-btn-xs, .ls-table th, .ls-table td {
    font-size: 10px !important;
  }
}
@media (max-width: 970px){
  .ls-btn a {
    display: none !important;
  }
}
.ls-main {
  -moz-transform: none;
  -ms-transform: none;
  -webkit-transform: none;
  transform: none;
}
.ls-main-full {
  z-index: 9;
  position: relative;
  padding-top: 70px;
}
.input-error {
  b {
    color: #d75553!important;
  }
  .ls-label-text-prefix {
    border-width: 1px 1px 1px 0px;
    border-style: solid;
    border-color: #d75553!important;
    color: #d75553!important;
  }
  input {
    border: 1px solid #d75553!important;
    border-left-width: 0!important;
  }
  .help-message {
    color: #d75553;
    font-size: 12px;
  }
  .icon {
    fill: #d75553;
  }
  .ls-custom-select {
    border-color: #d75553;
    color: #d75553;
    &:before {
      border-color: #d75553 transparent transparent transparent;
    }
    &:after {
      border-left: 1px solid #d75553;
    }
  }
}
.ls-box-filter {
  .btn-action {
    float: right;
    padding: 0 15px;
    margin: 0!important;
    @media screen and (max-width: 480px) {
      float: none;
      button, a {
        width: 100%;
        display: block;
        margin: 0 0 10px 0!important;
        &:last-child {
          margin: 0!important;
        }
      }
    }
  }
}
input[type="date"] {
  -webkit-appearance: none;
  padding: 12px 10px;
  display: inline-block;
  background: white;
  font-size: 14px;
  color: #555555;
  width: 100%;
  z-index: 1;
  -webkit-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
  -moz-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
  -ms-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
  -o-box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
  box-shadow: inset,0 1px 1px,rgba(0,0,0,0.075);
}
.v-select {
  .dropdown-toggle {
    position: relative;
    font-size: 13px;
    background: white!important;
    border: 1px solid rgb(222, 222, 222)!important;
    padding-right: 28px!important;
    input[type=search] {
      height: 33px!important;
      border-right: 1px solid #ddd!important;
      border-radius: 0!important;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 100%!important;
      border-right: 1px solid #dedede;
      &:focus {
        background: #fff;
      }
    }
    .selected-tag {
      left: 0;
      background: none;
      border: none;
      position: absolute;
      width: calc(100% - 34px);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 14px;
    }
  }
  .open-indicator {
    display: none!important;
  }
  &:before {
    content: "";
    width: 0;
    height: 0;
    margin-left: 5px;
    border-style: solid;
    border-width: 5px;
    border-color: #555555 transparent transparent transparent;
    position: absolute;
    top: 50%;
    margin-top: -2px;
    right: 10px;
    z-index: 2;
    pointer-events: none;
  }
}
.margin-bottom {
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// subscribe.vue?132b523e